module.exports = __webpack_public_path__ + "img/simon-logotype-blue.2fe4e2ec.svg";